<template>
  <div>
    <!--西南联交所，开始-->
    <div v-if="orgid=='ins_045'">
      <div class="g-foot jigou-1-foot" style="height: 221px;">
        <img style="height: 221px;" src="../../assets/jigou-1-bottom.png">
      </div>
    </div>
    <!--西南联交所，结束-->
    <!--省政府，开始-->
    <!--<div v-if="orgid=='ins_045'">
      <div class="g-foot jigou-1-foot jigou-foot-1000" style="height: 130px;">
        <img style="height: 130px;" src="../../assets/jigou/jigou-zhengfu-bottom.png">
      </div>
    </div>-->
    <!--省政府，结束-->
    <!--省国资委，开始-->
    <!--<div v-if="orgid=='ins_045'">
      <div class="g-foot jigou-1-foot" style="height: 166px;">
        <img style="height: 166px;" src="../../assets/jigou/jigou-gzw-bottom.png">
      </div>
    </div>-->
    <!--省国资委，结束-->

    <!--西藏产权，开始-->
    <div v-else-if="orgid=='ins_099'">
      <div class="g-foot jigou-1-foot" style="height: 254px;">
        <img style="height: 254px;" src="../../assets/jigou-2-bottom.png">
      </div>
    </div>
    <!--西藏产权，结束-->
    <!--河北产权，开始-->
    <div v-else-if="orgid=='ins_062'">
      <div class="g-foot jigou-1-foot" style="height: 296px;border-top:3px solid #9ab2ff;">
<!--        <img style="height: 296px;" src="../../assets/jigou-3-bottom.png">-->
        <div class="c-content">
          <div class="address clearFix">
            <div class="address-left">
              <div>
                联系地址：<span>河北省石家庄市石清路9号河北公共资源大厦</span>
              </div>
              <div style="margin-top: 16px;">
                联系电话：<span>0311-66635122</span>  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;传真：<span>0311-66635028</span>   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Email：<span>hbchanquan@126.com</span>
              </div>
              <div class="clearFix" style="margin-top: 16px;">
                <div class="phone-left">监督电话：</div>
                <div class="phone-right">
                  <div>
                    <span>河北省国资委&nbsp;&nbsp;&nbsp;产权处&nbsp;&nbsp;&nbsp;0311-87901019</span>
                  </div>
                  <div style="margin-top:10px;">
                    <span>河北省政务服务管理办公室&nbsp;&nbsp;&nbsp;公共资源交易监督处&nbsp;&nbsp;&nbsp;0311-66635518</span>
                  </div>
                </div>
              </div>
              <div style="clear:both;margin-top: 16px;">
                投诉电话：<span>河北产权市场综合信息部&nbsp;&nbsp;&nbsp;0311-66635177</span>
              </div>
            </div>
            <div class="address-right">
              <div class="erweima">
                <!--<img src="images/common/erweima.png">-->
              </div>
              <div>扫码关注</div>
            </div>
          </div>
          <div class="copyright clearFix">
            <div class="copyright-left">
              Copyright© 2001-2019 版权所有：河北产权市场 备案/许可证编号为：冀ICP备18003461号
            </div>
            <div class="copyright-right">
              技术支持：<a target="_blank" href="http://www.dscq.com/index.shtml">第四产权</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--河北产权，结束-->
    <!--重庆，开始-->
    <div v-else-if="orgid=='ins_043'">
      <div class="g-foot jigou-1-foot" style="height: 226px;">
        <img style="height: 226px;" src="../../assets/jigou/jigou-4-bottom.png">
      </div>
    </div>
    <!--重庆，结束-->
    <!--安徽省产权交易中心，开始-->
    <div v-else-if="orgid=='ins_039'">
      <div class="g-foot jigou-1-foot" style="height: 90px;">
        <img style="height: 90px;" src="../../assets/jigou/jigou-anhui-bottom.png">
      </div>
    </div>
    <!--安徽省产权交易中心，结束-->
    <!--大连，开始-->
    <div v-else-if="orgid=='ins_038'">
      <div class="g-foot jigou-1-foot" style="height: 120px;">
        <img style="height: 120px;" src="../../assets/jigou/jigou-dalian-bottom.png">
      </div>
    </div>
    <!--大连，结束-->
    <!--甘肃，开始-->
    <div v-else-if="orgid=='ins_008'">
      <div class="g-foot jigou-1-foot" style="height: 203px;">
        <img style="height: 203px;" src="../../assets/jigou/jigou-gansu-bottom.png">
      </div>
    </div>
    <!--甘肃，结束-->
    <!--深圳，开始-->
    <div v-else-if="orgid=='ins_031'">
      <div class="g-foot jigou-1-foot" style="height: 135px;">
        <img style="height: 135px;" src="../../assets/jigou/jigou-shenzhen-bottom.png">
      </div>
    </div>
    <!--深圳，结束-->
    <!--北部湾，开始-->
    <div v-else-if="orgid=='ins_005'">
      <div class="g-foot jigou-1-foot" style="height: 77px;">
        <img style="height: 77px;" src="../../assets/jigou/jigou-beibuwan-bottom.png">
      </div>
    </div>
    <!--北部湾，结束-->
    <!--河南省，开始-->
    <div v-else-if="orgid=='ins_049'">
      <div class="g-foot jigou-1-foot" style="height: 172px;">
        <img style="height: 172px;" src="../../assets/jigou/jigou-henansheng-bottom.png">
      </div>
    </div>
    <!--河南省，结束-->
    <!--河南中原，开始-->
    <div v-else-if="orgid=='ins_037'">
      <div class="g-foot jigou-1-foot" style="height: 105px;">
        <img style="height: 105px;" src="../../assets/jigou/jigou-henanzhongyuan-bottom.png">
      </div>
    </div>
    <!--河南中原，结束-->
    <!--黑龙江联合产权，开始-->
    <div v-else-if="orgid=='ins_012'">
      <div class="g-foot jigou-1-foot" style="height: 297px;">
        <img style="height: 297px;" src="../../assets/jigou/jigou-heilongjiang-bottom.png">
      </div>
    </div>
    <!--黑龙江联合产权，结束-->
    <!--武汉光谷，开始-->
    <div v-else-if="orgid=='ins_066'">
      <div class="g-foot jigou-1-foot" style="height: 211px;">
        <img style="height: 211px;" src="../../assets/jigou/jigou-wuhanguanggu-bottom.png">
      </div>
    </div>
    <!--武汉光谷，结束-->
    <!--青岛，开始-->
    <div v-else-if="orgid=='ins_040'">
      <div class="g-foot jigou-1-foot" style="height: 249px;">
        <img style="height: 249px;" src="../../assets/jigou/jigou-qingdao-bottom.png">
      </div>
    </div>
    <!--青岛，结束-->
    <!--青海，开始-->
    <div v-else-if="orgid=='ins_006'">
      <div class="g-foot jigou-1-foot" style="height: 203px;">
        <img style="height: 203px;" src="../../assets/jigou/jigou-qinghai-bottom.png">
      </div>
    </div>
    <!--青海，结束-->
    <!--西部，开始-->
    <div v-else-if="orgid=='ins_028'">
      <div class="g-foot jigou-1-foot" style="height: 140px;">
        <img style="height: 140px;" src="../../assets/jigou/jigou-xibu-bottom.png">
      </div>
    </div>
    <!--西部，结束-->
    <!--新疆产权交易所，开始-->
    <div v-else-if="orgid=='ins_014'">
      <div class="g-foot jigou-1-foot" style="height: 242px;">
        <img style="height: 242px;" src="../../assets/jigou/jigou-xinjiang-bottom.png">
      </div>
    </div>
    <!--新疆产权交易所，结束-->
    <!--山东，开始-->
    <div v-else-if="orgid=='ins_033'">
      <div class="g-foot jigou-1-foot" style="height: 228px;">
        <img style="height: 228px;" src="../../assets/jigou/jigou-shandong-bottom.png">
      </div>
    </div>
    <!--山东，结束-->
    <!--云南，开始-->
    <div v-else-if="orgid=='ins_015'">
      <div class="g-foot jigou-1-foot" style="height: 164px;">
        <img style="height: 164px;" src="../../assets/jigou/jigou-yunnan-bottom.png">
      </div>
    </div>
    <!--云南，结束-->

    <!--江苏，开始-->
    <div v-else-if="orgid=='ins_010'">
      <div class="g-foot jigou-1-foot" style="height: 176px;">
        <img style="height: 176px;" src="../../assets/jigou/jigou-jiangsu-bottom.png">
      </div>
    </div>
    <!--江苏，结束-->
    <!--江西，开始-->
    <div v-else-if="orgid=='ins_016'">
      <div class="g-foot jigou-1-foot" style="height: 233px;">
        <img style="height: 233px;" src="../../assets/jigou/jigou-jiangxi-bottom.png">
      </div>
    </div>
    <!--江西，结束-->
    <!--广州，开始-->
    <div v-else-if="orgid=='ins_035'">
      <div class="g-foot jigou-1-foot" style="height: 106px;">
        <img style="height: 106px;" src="../../assets/jigou/jigou-guangzhou-bottom.png">
      </div>
    </div>
    <!--广州，结束-->
    <!--沈阳，开始-->
    <div v-else-if="orgid=='ins_046'">
      <div class="g-foot jigou-1-foot" style="height: 130px;">
        <img style="height: 130px;" src="../../assets/jigou/jigou-shenyang-bottom.png">
      </div>
    </div>
    <!--沈阳，结束-->
    <!--天津，开始-->
    <div v-else-if="orgid=='ins_003'">
      <div class="g-foot jigou-1-foot" style="height: 97px;">
        <img style="height: 97px;" src="../../assets/jigou/jigou-tianjin-bottom.png">
      </div>
    </div>
    <!--天津，结束-->
    <!--海南，开始-->
    <div v-else-if="orgid=='ins_017'">
      <div class="g-foot jigou-1-foot" style="height: 145px;">
        <img style="height: 145px;" src="../../assets/jigou/jigou-hainan-bottom.png">
      </div>
    </div>
    <!--海南，结束-->
    <!--福建，开始-->
    <div v-else-if="orgid=='ins_052'">
      <div class="g-foot jigou-1-foot" style="height: 160px;">
        <img style="height: 160px;" src="../../assets/jigou/jigou-fujian-bottom.png">
      </div>
    </div>
    <!--福建，结束-->
    <!--广西，开始-->
    <div v-else-if="orgid=='ins_061'">
      <div class="g-foot jigou-1-foot" style="height: 124px;">
        <img style="height: 124px;" src="../../assets/jigou/jigou-guangxi-bottom.png">
      </div>
    </div>
    <!--广西，结束-->
    <!--珠海，开始-->
    <div v-else-if="orgid=='ins_067'">
      <div class="g-foot jigou-1-foot" style="height: 238px;">
        <img style="height: 238px;" src="../../assets/jigou/jigou-zhuhai-bottom.png">
      </div>
    </div>
    <!--珠海，结束-->
    <!--杭州，开始-->
    <div v-else-if="orgid=='ins_068'">
      <div class="g-foot jigou-1-foot" style="height: 133px;">
        <img style="height: 133px;" src="../../assets/jigou/jigou-hangzhou-bottom.png">
      </div>
    </div>
    <!--杭州，结束-->
    <!--宁波，开始-->
    <div v-else-if="orgid=='ins_041'">
      <div class="g-foot jigou-1-foot" style="height: 241px;">
        <img style="height: 241px;" src="../../assets/jigou/jigou-ningbo-bottom.jpg">
      </div>
    </div>
    <!--宁波，结束-->

  </div>
</template>

<script>
  import global from '../../components/public/Common.vue';

  export default {
    name: '', // Do not use built-in or reserved HTML elements as component id
    data() {
      return {
        orgid: global.orgid
      }
    }
  }
</script>
<style scoped>
  @import "../../style/common.css";
</style>
<style lang="stylus">
  .g-foot .address .address-left {
    float: left;
    color: #333;
    font-size: 14px;
  }

  .g-foot .address .address-left span {
    font-size: 16px;
  }

  .g-foot .address .address-left .phone-left {
    float: left;
  }

  .g-foot .address .address-left .phone-right {
    float: left;
  }

  .g-foot .address .address-right {
    float: right;
    margin-right: 60px;
    text-align: center;
  }

  .g-foot .address .address-right a {
    color: #fff;
    display: inline-block;
    margin-right: 15px;
    width: 116px;
    height: 40px;
    line-height: 40px;
    background: rgba(255, 102, 19, 1);
    opacity: 0.9;
    border-radius: 4px;
    font-weight: bold;
  }

  .g-foot .address .address-right .erweima {
    display :block;
    position:static;
    width: 110px;
    height: 110px;
    background: url(../../assets/jigou/hb-erweima.png) no-repeat;
  }

  .g-foot .address span {
    font-weight: bold;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/Foot.vue